import { render, staticRenderFns } from "./Wire.vue?vue&type=template&id=6cb0e4aa&scoped=true"
import script from "./Wire.vue?vue&type=script&lang=js"
export * from "./Wire.vue?vue&type=script&lang=js"
import style0 from "./Wire.vue?vue&type=style&index=0&id=6cb0e4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb0e4aa",
  null
  
)

export default component.exports